import { g0ToUnicode } from './charset.ts';
import { decodePage } from './decoder.ts';
import { COLS, type Row } from './types.ts';

export interface TextOptions {
  /** Include concealed text (as if Reveal were pressed). Default true. */
  reveal?: boolean;
  /** Character to stand in for mosaic graphics. Default ' '. */
  mosaic?: string;
  /** Skip row 0 (the header). Default true. */
  skipHeader?: boolean;
}

/**
 * Plain-text rendering of a page for screen readers and text alternatives:
 * one line per displayed row, attributes as spaces, double-height lower
 * halves omitted, trailing whitespace trimmed.
 */
export function pageToText(rows: Row[], opts: TextOptions = {}): string {
  const reveal = opts.reveal ?? true;
  const mosaic = opts.mosaic ?? ' ';
  const lines: string[] = [];
  for (const dr of decodePage(rows)) {
    if ((opts.skipHeader ?? true) && dr.row === 0) continue;
    if (dr.suppressed) continue;
    let line = '';
    for (let x = 0; x < COLS; x++) {
      const c = dr.cells[x]!;
      if (c.mosaic) line += mosaic;
      else if (c.conceal && !reveal) line += ' ';
      else line += g0ToUnicode(c.glyph);
    }
    lines.push(line.replace(/\s+$/, ''));
  }
  return lines.join('\n').replace(/\n+$/, '');
}
